/** 問題一覧と各ページに表示するタイトル・解説。 */
export interface QuestionDescription {
  title: string
  /** リポジトリ内で管理する固定HTML。外部入力を混ぜないこと。 */
  desc: string
}

const questionRows: readonly (readonly [title: string, description: string])[] = [
  [
    'チャンネル入れ替え',
    'RGB の赤と青を交換して BGR の並びにする。画素配列のチャンネル構造を確認する最初の問題。',
  ],
  ['グレースケール', '各画素を輝度 <code>Y = 0.2126R + 0.7152G + 0.0722B</code> へ変換する。'],
  ['二値化', 'グレースケール画像を閾値128で0と255に分け、前景と背景だけの画像を作る。'],
  [
    '大津の二値化',
    'クラス間分散が最大となる閾値をヒストグラムから探索し、画像に適した二値化閾値を自動決定する。',
  ],
  ['HSV変換', 'RGBを色相・彩度・明度へ変換し、色相を180度反転してからRGBへ戻す。'],
  ['減色処理', '各チャンネルを32・96・160・224の4段階へ量子化し、扱う色数を減らす。'],
  ['平均プーリング', '画像を8×8画素の領域に分け、各領域をチャンネルごとの平均値で塗りつぶす。'],
  ['Maxプーリング', '8×8画素の領域ごとに最大値を選び、強い応答を残したまま情報を集約する。'],
  [
    'ガウシアンフィルタ',
    '3×3・標準偏差1.3のガウシアンカーネルで畳み込み、ノイズと細かな変化を平滑化する。',
  ],
  ['メディアンフィルタ', '注目画素の3×3近傍を並べ、中央値で置き換えてごま塩ノイズを抑える。'],
  ['平滑化フィルタ', '3×3近傍の平均を取るローパスフィルタ。局所的な濃度変化をなだらかにする。'],
  [
    'モーションフィルタ',
    '斜め方向に値を持つカーネルを畳み込み、カメラが動いたような流れを加える。',
  ],
  [
    'MAX-MINフィルタ',
    '3×3近傍の最大値と最小値の差を出力し、局所的な濃度差をエッジとして強調する。',
  ],
  ['微分フィルタ', '隣接画素との差分から水平方向・垂直方向の輪郭を抽出する。'],
  ['Sobelフィルタ', '中心に重みを付けたSobelカーネルでx・y方向の輝度勾配を求める。'],
  ['Prewittフィルタ', 'Prewittカーネルによる一次微分で水平・垂直エッジを検出する。'],
  ['Laplacianフィルタ', '二次微分で方向に依存しない急峻な濃度変化を抽出する。'],
  ['Embossフィルタ', '対角方向の明暗差に中間輝度を加え、浮き彫りのような見た目を作る。'],
  ['LoGフィルタ', 'ガウシアン平滑化とLaplacianを組み合わせ、ノイズを抑えながらエッジを抽出する。'],
  [
    'ヒストグラム表示',
    '各画素値の出現回数を数え、画像の明るさとコントラストの分布をグラフで確認する。',
  ],
  ['ヒストグラム正規化', '最小値と最大値を指定範囲へ線形変換し、狭い濃度分布を広げる。'],
  ['ヒストグラム操作', '平均と標準偏差を指定値へ合わせ、濃度分布の中心と広がりを変える。'],
  [
    'ヒストグラム平坦化',
    '累積ヒストグラムを使って画素値を再配分し、画像全体のコントラストを均一化する。',
  ],
  ['ガンマ補正', '非線形な入出力特性を逆補正し、暗部または明部の見え方を調整する。'],
  ['最近傍補間', '変換先画素に最も近い入力画素を選ぶ、単純で高速な拡大処理。ここでは1.5倍にする。'],
  ['Bi-linear補間', '周囲4画素を距離に応じて線形補間し、最近傍法より滑らかに1.5倍へ拡大する。'],
  ['Bi-cubic補間', '周囲16画素を3次関数で補間し、輪郭を保ちながら滑らかに拡大する。'],
  [
    'アフィン変換（平行移動）',
    '同次座標のアフィン行列を使い、画像をx方向30画素・y方向30画素だけ移動する。',
  ],
  [
    'アフィン変換（拡大縮小）',
    'アフィン行列の対角成分を倍率として、画像を幾何学的に拡大・縮小する。',
  ],
  ['アフィン変換（回転）', '逆写像で入力座標を求め、画像中心を基準に反時計回りへ回転する。'],
  [
    'アフィン変換（スキュー）',
    '座標軸を傾けるせん断変換を適用し、矩形画像を平行四辺形へ変形する。',
  ],
  [
    'フーリエ変換',
    '2次元離散フーリエ変換で空間画像を周波数成分へ分解し、逆変換で復元する。計算に時間がかかる場合がある。',
  ],
  [
    'フーリエ変換 ローパスフィルタ',
    '周波数領域の中心付近だけを残し、高周波の細部やノイズを除去する。',
  ],
  ['フーリエ変換 ハイパスフィルタ', '低周波成分を除き、高周波に含まれる輪郭や細かな模様を残す。'],
  [
    'フーリエ変換 バンドパスフィルタ',
    '指定した周波数帯だけを通過させ、特定スケールの模様を抽出する。',
  ],
  [
    'JPEG圧縮 Step.1 DCT',
    '8×8ブロックごとに離散コサイン変換と逆変換を行い、空間情報を周波数係数へ移す。',
  ],
  ['PSNR', '原画像と復元画像の平均二乗誤差からPSNRを計算し、圧縮による画質変化を数値化する。'],
  [
    'JPEG圧縮 Step.2 DCT＋量子化',
    'DCT係数を量子化テーブルで丸め、高周波情報を削減してJPEG圧縮の中心処理を再現する。',
  ],
  [
    'JPEG圧縮 Step.3 YCbCr表色系',
    'RGBを輝度Yと色差Cb・Crへ変換し、人の視覚特性に合った成分へ分離する。',
  ],
  [
    'JPEG圧縮 Step.4 YCbCr＋DCT＋量子化',
    'YCbCr変換、DCT、量子化、逆変換をつなぎ、JPEG風の圧縮・復元を行う。',
  ],
  [
    'Cannyエッジ検出 Step.1 エッジ強度',
    'ガウシアン平滑化後にSobel勾配を求め、勾配強度と量子化した方向を出力する。',
  ],
  [
    'Cannyエッジ検出 Step.2 細線化',
    '勾配方向に沿った非極大値抑制で、太いエッジ応答を1画素程度へ細くする。',
  ],
  [
    'Cannyエッジ検出 Step.3 ヒステリシス閾処理',
    '強いエッジと、それにつながる弱いエッジだけを残す二段階の閾値処理を行う。',
  ],
  [
    'Hough変換・直線検出 Step.1 Hough変換',
    'エッジ画素を角度θ・距離ρの空間へ投票し、画像中の直線候補を蓄積する。',
  ],
  [
    'Hough変換・直線検出 Step.2 NMS',
    'Hough空間で近傍より大きい極大値だけを残し、重複した直線候補を抑制する。',
  ],
  [
    'Hough変換・直線検出 Step.3 Hough逆変換',
    '投票数の多い(ρ, θ)を画像上の直線へ戻し、入力画像へ重ねて描画する。',
  ],
  [
    'モルフォロジー処理（膨張）',
    '二値画像の4近傍に前景があれば注目画素も前景にし、白領域を広げる。',
  ],
  ['モルフォロジー処理（収縮）', '4近傍に背景があれば注目画素も背景にし、白領域を縮める。'],
  ['オープニング処理', '収縮の後に膨張を行い、大きな形を保ちながら小さな前景ノイズを除去する。'],
  ['クロージング処理', '膨張の後に収縮を行い、前景内部の小さな穴や切れ目を埋める。'],
  ['モルフォロジー勾配', '膨張画像から収縮画像を引き、物体境界の帯だけを取り出す。'],
  ['トップハット変換', '原画像からオープニング結果を引き、背景より明るい小さな領域を抽出する。'],
  ['ブラックハット変換', 'クロージング結果から原画像を引き、背景より暗い小さな領域を抽出する。'],
  [
    'テンプレートマッチング SSD',
    'テンプレートとの画素差の二乗和が最小になる位置を探索し、対応領域を矩形で示す。',
  ],
  [
    'テンプレートマッチング SAD',
    '画素差の絶対値和を評価値として、テンプレートに最も近い位置を探索する。',
  ],
  [
    'テンプレートマッチング NCC',
    '正規化相互相関が最大となる位置を求め、明るさのスケール差に強い照合を行う。',
  ],
  [
    'テンプレートマッチング ZNCC',
    '平均値を引いた正規化相互相関を用い、明るさの加算変化にも強い照合を行う。',
  ],
  ['ラベリング 4近傍', '上下左右でつながる前景画素に同じラベルを付け、連結成分ごとに色分けする。'],
  ['ラベリング 8近傍', '斜めを含む8方向の接続を同じ領域として扱い、連結成分を抽出する。'],
  [
    'アルファブレンド',
    '2枚の画像を同じ大きさにそろえ、各画素を <code>0.5A + 0.5B</code> で合成する。',
  ],
  ['4-連結数', '注目画素の周囲を巡回して4連結数を求め、形状の内部・端点・分岐などを分類する。'],
  ['8-連結数', '8近傍の接続関係を数え、二値図形の局所的な構造を色分けする。'],
  ['細線化処理', '反復的なモルフォロジー条件で輪郭画素を削り、図形の骨格を1画素幅へ近づける。'],
  ['ヒルディッチの細線化', '連結性を壊さない削除条件を反復し、二値図形の中心線を抽出する。'],
  ['Zhang-Suenの細線化', '2種類の削除条件を交互に適用し、収束するまで輪郭画素を除去する。'],
  [
    'HOG Step.1 勾配強度・勾配角度',
    'x・y方向の輝度差から勾配強度と角度を求め、角度を0〜180度の9方向へ量子化する。',
  ],
  [
    'HOG Step.2 勾配ヒストグラム',
    '画像を8×8画素のセルに分け、各画素の勾配強度を9方向のビンへ投票する。',
  ],
  [
    'HOG Step.3 ヒストグラム正規化',
    '周囲3×3セルをブロックとしてL2正規化し、局所的な明るさやコントラストの差を抑える。',
  ],
  [
    'HOG Step.4 特徴量の描画',
    '正規化した9方向ヒストグラムをセル中心の線分として描き、形状特徴を可視化する。',
  ],
  [
    'カラートラッキング',
    'RGBをHSVへ変換し、色相が青の範囲にある画素だけを二値画像として抽出する。',
  ],
  ['マスキング', 'カラートラッキングで得た二値マスクを使い、対象色の領域だけを残す。'],
  [
    'マスキング（色追跡＋モルフォロジー）',
    '色によるマスクをクロージングとオープニングで整え、孤立ノイズや穴を減らす。',
  ],
  [
    '縮小と拡大',
    '画像を一度縮小してから元の大きさへ戻し、解像度低下が画像へ与える影響を確認する。',
  ],
  [
    'ピラミッド差分による高周波成分',
    '原画像と縮小・拡大画像の差を取り、細かな模様や輪郭などの高周波成分を抽出する。',
  ],
  ['ガウシアンピラミッド', '異なる倍率へ繰り返し縮小し、同じ画像を複数の空間スケールで表現する。'],
  ['顕著性マップ', '複数スケールの画像差を統合し、周囲と異なって目立つ領域を強調する。'],
  [
    'ガボールフィルタ',
    'ガウシアン窓と正弦波を組み合わせたカーネルを生成し、方向と周波数を持つ模様に応答させる。',
  ],
  [
    'ガボールフィルタの回転',
    '0・45・90・135度のガボールカーネルを生成し、方向ごとの形状を比較する。',
  ],
  [
    'ガボールフィルタによるエッジ抽出',
    '複数方向のガボールフィルタを画像へ適用し、それぞれの方向に沿う輪郭を抽出する。',
  ],
  [
    'ガボールフィルタによる特徴抽出',
    '方向別のガボール応答を合成し、向きに偏らないテクスチャ特徴を作る。',
  ],
  [
    'Hessianのコーナー検出',
    '二階微分からHessian行列の行列式を求め、局所最大となる点をコーナーとして検出する。',
  ],
  [
    'Harrisのコーナー検出 Step.1',
    'Sobel勾配の積をガウシアン平滑化し、各画素の構造テンソル成分を求める。',
  ],
  [
    'Harrisのコーナー検出 Step.2',
    '構造テンソルの行列式とトレースからHarris応答を計算し、局所最大点を描画する。',
  ],
  [
    '簡単な画像認識 Step.1 減色＋ヒストグラム',
    'RGB各チャンネルを4階調へ減色し、合計12次元の色ヒストグラムを特徴量として得る。',
  ],
  [
    '簡単な画像認識 Step.2 クラス判別',
    'テスト画像と学習画像の色ヒストグラム距離を比較し、最も近い画像のクラスを予測する。',
  ],
  [
    '簡単な画像認識 Step.3 Accuracy',
    '予測ラベルと正解ラベルを比較し、正解数を全テスト数で割ったAccuracyを求める。',
  ],
  [
    '簡単な画像認識 Step.4 k-NN',
    '距離が近い複数の学習画像を選び、その多数決でテスト画像のクラスを決める。',
  ],
  [
    'K-means Step.1 重心作成',
    '画像特徴へランダムな初期ラベルを割り当て、クラスごとの平均ベクトルを重心として計算する。',
  ],
  [
    'K-means Step.2 クラスタリング',
    '各特徴を最も近い重心へ割り当て直し、重心が収束するまで更新を繰り返す。',
  ],
  [
    'K-means Step.3 初期ラベルの変更',
    '10枚の学習画像を2群へクラスタリングし、初期値が結果へ与える影響を確認する。',
  ],
  [
    'K-means減色 Step.1 色分類',
    '画像から5色を初期重心として選び、各画素をRGB距離が最も近いクラスへ割り当てる。',
  ],
  [
    'K-means減色 Step.2 減色',
    '画素の割り当てと代表色の平均更新を収束まで反復し、画像を5色で表現する。',
  ],
  [
    '学習データ準備 Step.1 IoU',
    '2つの矩形の共通部分を和集合で割り、重なりを0〜1で表すIntersection over Unionを計算する。',
  ],
  [
    '学習データ準備 Step.2 ランダムクロップ',
    '画像から60×60の矩形を200個切り出し、正解矩形とのIoUが0.5以上なら正例とする。',
  ],
  [
    'ニューラルネットワーク Step.1 多層化',
    '2つの隠れ層を持つ全結合ネットワークを誤差逆伝播で学習し、XORを分類する。',
  ],
  [
    'ニューラルネットワーク Step.2 学習',
    'ランダムクロップのHOG特徴量を入力にして顔・非顔を学習し、学習データ上のAccuracyを測る。',
  ],
  [
    '簡単な物体検出 Step.1 スライディングウィンドウ',
    '3種類の大きさの窓を4画素ずつ移動し、各領域を32×32へ縮小してHOG特徴量を抽出する。',
  ],
  [
    '簡単な物体検出 Step.2 NN',
    '各スライディングウィンドウのHOGを学習済みネットワークへ入力し、スコア0.7以上の候補を描画する。',
  ],
  [
    '簡単な物体検出 Step.3 NMS',
    '候補をスコア順に並べ、IoUが0.25以上重なる低スコアの矩形を除いて重複検出を抑える。',
  ],
  [
    '簡単な物体検出 Step.4 評価',
    'IoU 0.5を正解条件としてRecall・Precision・F-score・mAPを計算し、100問の処理を完成させる。',
  ],
]

export const descriptions: Record<number, QuestionDescription> = Object.fromEntries(
  questionRows.map(([title, desc], index) => [index + 1, { title, desc }]),
)

/** 指定した番号の説明を返す。範囲外ならタイトル・解説とも空。 */
export function getDescription(id: number): QuestionDescription {
  return descriptions[id] ?? { title: '', desc: '' }
}

export default descriptions
